import React from "react";

import { Text } from "web/react/emo/text";

import { ResponsiveTextStyle } from "web/react/emo/sprinkles.css";
import * as styles from "./image-container.css";

interface ImageContainerProps {
    imageSrc: string;
    imageCredit: string | null;
    alt?: string;
    width?: number;
    height?: number;
    textStyle?: ResponsiveTextStyle;
}

export function ImageContainer({
    imageSrc,
    imageCredit,
    alt,
    width,
    height,
    textStyle = "caption-3",
}: ImageContainerProps): React.ReactElement {
    return (
        <div className={styles.imageContainer}>
            <img
                data-testid="introimage"
                className={styles.image}
                width={width}
                height={height}
                src={imageSrc}
                alt={alt}
            />
            {imageCredit && (
                <Text className={styles.imageCredit} textStyle={textStyle} upperCase>
                    {imageCredit}
                </Text>
            )}
        </div>
    );
}
